import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { HttpService } from "../../components/services/HttpService";
import { UserTypeConstants } from "../types/UserTypeConstants";
import { history } from '../../components/helpers/History';
import { UserActions } from "../actions/UserActions";
import { BackDropActions } from "../actions/BackDropActions";
import { AlertActions } from "../actions/AlertActions";

function* register(action) {
  try {
    var payload = action.user;
    payload.username=payload.email;
    yield put(BackDropActions.start());
    const user = yield call(HttpService.post,"/users/register",payload);
    yield put(UserActions.registerSuccess(user));
  } catch (e) {
    yield put(UserActions.registerFailiure(e));
  }
}

function* registerSuccess(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.success('Registration successful'));
    history.push('/home');
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}

function* registerFailiure(action) {
  try {
    yield put(BackDropActions.end());
    yield put(AlertActions.error(action.message));
    //localStorage.clear();
  } catch (e) {
    yield put(AlertActions.error(e));
  }
}


function* userRegistration() {
  yield takeEvery(UserTypeConstants.REGISTER_REQUEST, register);
  yield takeEvery(UserTypeConstants.REGISTER_SUCCESS, registerSuccess);
  yield takeEvery(UserTypeConstants.REGISTER_FAILURE, registerFailiure);
  
}

export default userRegistration;
